/**
 * Block page / parent-frame scroll while the embedded game is active.
 * Touch drags on Fall movement and the playfield should not scroll the host site.
 */

var VOLUME_CONTROL_SELECTOR =
  "#fallVolumeOverlay, .fall-volume-overlay, .fall-volume-slider, input[type='range']";

var TOUCH_SCROLL_ALLOW_SELECTOR =
  "[data-touch-scroll], [data-touch-scroll='y'], [data-touch-scroll='x'],"
  + " .stash__items-row, .dev-fps-overlay, .dev-stats-overlay,"
  + " .dev-perf-dialog, .dev-perf-dialog__panel, .dev-perf-dialog *";

/**
 * Volume sliders must receive the touchmove default action. Cancelling it
 * leaves the thumb stuck, so the music slider never changes BGM loudness.
 * @param {EventTarget | null | undefined} target
 * @returns {boolean}
 */
export function isVolumeControlTarget(target) {
  if (!target || typeof target.closest !== "function") return false;
  return !!target.closest(VOLUME_CONTROL_SELECTOR);
}

/** Playfield only — do not block context menu on dev chips or form fields. */
var CONTEXT_MENU_BLOCK_SELECTOR =
  "#gameCanvas, #playChrome, .shake-jar-chrome, #fallMoveHint, #shakeDropHint, #playerPauseHint";

var CONTEXT_MENU_ALLOW_SELECTOR =
  ".dev-fps-overlay, .dev-stats-overlay, .dev-perf-dialog, .dev-perf-dialog *,"
  + " input, textarea, select, [contenteditable='true']";

function isTouchScrollAllowed(target) {
  if (isVolumeControlTarget(target)) return true;
  if (!target || typeof target.closest !== "function") return false;
  return !!target.closest(TOUCH_SCROLL_ALLOW_SELECTOR);
}

function shouldBlockContextMenu(target) {
  if (!target || typeof target.closest !== "function") return false;
  if (target.closest(CONTEXT_MENU_ALLOW_SELECTOR)) return false;
  return !!target.closest(CONTEXT_MENU_BLOCK_SELECTOR);
}

function onContextMenu(event) {
  if (!event || !event.target) return;
  if (!shouldBlockContextMenu(event.target)) return;
  event.preventDefault();
}

function onTouchMove(event) {
  if (!event || event.cancelable === false) return;
  if (isTouchScrollAllowed(event.target)) return;
  event.preventDefault();
}

function onWindowScroll() {
  if (typeof window === "undefined") return;
  if (window.scrollX !== 0 || window.scrollY !== 0) {
    window.scrollTo(0, 0);
  }
}

/**
 * Install document-level guards for embedded/mobile play.
 * Safe to call more than once.
 */
export function installEmbedScrollGuard() {
  if (typeof document === "undefined") return;
  var root = document.documentElement;
  if (!root || root.classList.contains("game-embed-scroll-lock")) return;
  root.classList.add("game-embed-scroll-lock");

  document.addEventListener("touchmove", onTouchMove, { passive: false, capture: true });
  document.addEventListener("contextmenu", onContextMenu, true);
  if (typeof window !== "undefined") {
    window.addEventListener("scroll", onWindowScroll, { passive: true });
  }
}